export { RegistrationComponent } from './registration.component';
export { RegistrationModule } from './registration.module';
